import React, { useEffect, useState } from 'react';
import { useUIUtils } from 'hooks/useUIUtils';
import { currency } from 'resources/utilities';
//import { fetchConToken } from 'helpers/fetch';
//import { alertService } from '_services';
//import Swal from 'sweetalert2';
import { /*avisarError,*/ Campo, cargar, sucursalActual, Tarjeta } from '../comun';

const fechaLocal = (fecha = new Date()) => {
    const mes = String(fecha.getMonth() + 1).padStart(2, '0');
    const dia = String(fecha.getDate()).padStart(2, '0');
    return `${fecha.getFullYear()}-${mes}-${dia}`;
};

const inicioMes = () => {
    const fecha = new Date();
    return fechaLocal(new Date(fecha.getFullYear(), fecha.getMonth(), 1));
};

const Movimientos = () => {
    const { changeGlobalTitle } = useUIUtils();
    const [cajas, setCajas] = useState([]);
    const [movimientos, setMovimientos] = useState([]);
    const [retiros, setRetiros] = useState([]);
    const [consultado, setConsultado] = useState(false);
    const [filtro, setFiltro] = useState({ cajaId: '0', tipoMov: 'T', tipoRetiro: 'T', fechaInicio: inicioMes(), fechaFin: fechaLocal() });

    useEffect(() => {
        changeGlobalTitle('Movimientos de caja', 'Filtre por caja y fechas para ver aperturas, cierres, retiros e ingresos.');
        cargar(`pv/PvCajas/GetList?sucursal_Id=${sucursalActual()}&almacen_id=0&paginas=0&totalXpagina=200&busqueda=`).then(setCajas);
    }, [changeGlobalTitle]);

    function consultar() {
        const base = `sucursal_id=${sucursalActual()}&caja_id=${filtro.cajaId || 0}&fechaInicio=${filtro.fechaInicio}&fechaFin=${filtro.fechaFin}&paginas=1&totalXpagina=100`;
        cargar(`pv/PvCajas/Movimientos?${base}&tipo=${filtro.tipoMov}`).then(setMovimientos);
        cargar(`pv/PvCajas/RetirosIngresos?${base}&tipo=${filtro.tipoRetiro}`).then(setRetiros);
        setConsultado(true);
    }

    function nombreCaja(id) {
        return cajas.find((item) => String(item.id) === String(id))?.nombre || id;
    }

    /*function eliminar(retiroId) {
        Swal.fire({ text: 'Se eliminara el retiro o ingreso', icon: 'warning', showCancelButton: true, confirmButtonText: 'Eliminar', cancelButtonText: 'Cancelar' })
            .then((result) => {
                if (!result.isConfirmed) return;
                fetchConToken('pv/PvCajas/EliminarRetiroIngreso', { id: retiroId }, 'POST').then((response) => {
                    if (avisarError(response)) return;
                    consultar();
                }).catch(alertService.error);
            });
    }*/

    return (
        <div className='container-fluid'>
            <Tarjeta titulo='Filtros'>
                <div className='row'>
                    <div className='col-md-3'>
                        <Campo label='Caja'>
                            <select className='form-select' value={filtro.cajaId} onChange={({ target }) => setFiltro({ ...filtro, cajaId: target.value })}>
                                <option value='0'>Todas</option>
                                {cajas.map((item) => <option key={item.id} value={item.id}>{item.nombre}</option>)}
                            </select>
                        </Campo>
                    </div>
                    <div className='col-md-2'><Campo label='Desde'><input type='date' className='form-control' value={filtro.fechaInicio} onChange={({ target }) => setFiltro({ ...filtro, fechaInicio: target.value })} /></Campo></div>
                    <div className='col-md-2'><Campo label='Hasta'><input type='date' className='form-control' value={filtro.fechaFin} onChange={({ target }) => setFiltro({ ...filtro, fechaFin: target.value })} /></Campo></div>
                    <div className='col-md-2'>
                        <Campo label='Aperturas y cierres'>
                            <select className='form-select' value={filtro.tipoMov} onChange={({ target }) => setFiltro({ ...filtro, tipoMov: target.value })}>
                                <option value='T'>Todos</option>
                                <option value='A'>Aperturas</option>
                                <option value='C'>Cierres</option>
                            </select>
                        </Campo>
                    </div>
                    <div className='col-md-3'>
                        <Campo label='Retiros e ingresos'>
                            <select className='form-select' value={filtro.tipoRetiro} onChange={({ target }) => setFiltro({ ...filtro, tipoRetiro: target.value })}>
                                <option value='T'>Todos</option>
                                <option value='R'>Retiros</option>
                                <option value='I'>Ingresos</option>
                            </select>
                        </Campo>
                    </div>
                </div>
                <button type='button' className='btn btn-outline-primary' onClick={consultar}>Consultar</button>
            </Tarjeta>
            {consultado && (
                <>
                    <Tarjeta titulo='Aperturas y cierres'>
                        <table className='table table-sm'>
                            <thead><tr><th>Caja</th><th>Fecha</th><th>Hora</th><th>Tipo</th></tr></thead>
                            <tbody>
                                {movimientos.length === 0 ? <tr><td colSpan='4'>Sin movimientos</td></tr> : movimientos.map((item) => (
                                    <tr key={item.id}>
                                        <td>{nombreCaja(item.caja_Id)}</td>
                                        <td>{String(item.fecha || '').slice(0, 10)}</td>
                                        <td>{item.hora}</td>
                                        <td>{item.tipo_Movimiento === 'A' ? 'Apertura' : item.tipo_Movimiento === 'C' ? 'Cierre' : item.tipo_Movimiento}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </Tarjeta>
                    <Tarjeta titulo='Retiros e ingresos'>
                        <table className='table table-sm'>
                            <thead><tr><th>Caja</th><th>Folio</th><th>Fecha</th><th>Tipo</th><th>Persona</th><th>Importe</th><th></th></tr></thead>
                            <tbody>
                                {retiros.length === 0 ? <tr><td colSpan='7'>Sin retiros ni ingresos</td></tr> : retiros.map((item) => (
                                    <tr key={item.id}>
                                        <td>{nombreCaja(item.caja_Id)}</td>
                                        <td>{item.folio}</td>
                                        <td>{String(item.fecha || '').slice(0, 10)}</td>
                                        <td>{item.tipo === 'I' ? 'Ingreso' : 'Retiro'}</td>
                                        <td>{item.persona}</td>
                                        <td>{currency(item.importe_Neto)}</td>
              
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </Tarjeta>
                </>
            )}
        </div>
    );
};

export { Movimientos };
